import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';

import { connect } from 'react-redux';

import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { process as kendoProcess } from '@progress/kendo-data-query';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';
import { dashboardContent } from '../../../localization/en-us/dashboardContent';
import BobLoadingMask from '../../../components/BobLoadingMask';
import BobWorkbookModeButton from '../../../components/BobWorkbookModeButton';

import * as ruleActions from '../../../actions/ruleActions';
import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';

import classes from './Table.module.css';

const initialDataStateFilter = {
    logic:   'and',
    filters: []
};

const initialDataState = {
    fitler: initialDataStateFilter,
    sort:   [],
    take:   20,
    skip:   0
};

const ViewTargets = ({
    activeNavCompany,
    bobLoading,
    fetchRuleTargets,
    rule,
    history,
    setWorkBookMode,
    targetsList,
    targetsMeta,
    workbookModeEnabled,
    ...props
}) => {
    const [take, setTake] = useState(20);
    const [pageable] = useState({ pageSizes: true });
    const [gridDataState, setGridDataState] = useState(initialDataState);

    useEffect( () => {
        async function init() {
            await fetchRuleTargets(rule.id);
        }
        if (rule && rule.id) init();
    }, [rule]);

    useEffect(() => {
        if (!workbookModeEnabled) {
            initialDataState.take = take;
            setGridDataState(initialDataState);
        }
    }, [workbookModeEnabled]);
    
    const refreshGrid = () => {
        async function refresh() {
            await fetchRuleTargets(rule.id);
        }
        if (rule && rule.id) refresh();
    };

    const onDataStateChange = e => {
        setTake(e.dataState.take);
        setGridDataState(e.dataState);
    };

    const handleWorkbookMode = () => {
        setWorkBookMode(!workbookModeEnabled);
    };

    return (
        <div className={classes.ViewTargets}>
            <div className={classes.RuleNameContainet}>
                <span>Rule</span><br />
                <p className={classes.RuleName}>{rule ? rule.name : ''}</p>
            </div>
            <div className={classes.WorkbookContainer}>
                <BobWorkbookModeButton
                    handleWorkbookMode={handleWorkbookMode}
                    workbookMode={workbookModeEnabled}
                />
            </div>
            <div
                className={classes.RefreshContainer}
                aria-hidden="true"
                role="button"
                tabIndex={0}
                onClick={refreshGrid}
            >
                <span className="material-icons-outlined">refresh</span>
            </div>
            <div className={classes.GridContainer}>
                <div className={classes.Table}>
                    <div className={classes.TablePanel}>
                        <style>
                            { kendoGridInlineStyling }
                        </style>
                        <Grid
                            sortable
                            className={classes.KendoGrid}
                            data={kendoProcess(targetsList, gridDataState)}
                            { ...gridDataState }
                            onDataStateChange={onDataStateChange}
                            pageable={pageable}
                            reorderable
                            filterable={workbookModeEnabled}
                        >
                            <Column
                                field={'clientName'} title={dashboardContent.client} width="auto"
                                filter="text"
                            />
                            <Column
                                field={'siteName'} title={dashboardContent.site} width="auto"
                                filter="text"
                            />
                            <Column
                                field="systemEquipmentName" title={dashboardContent.target} width="auto"
                                filter="text"
                            />
                        </Grid>
                    </div>
                </div>{
                    bobLoading.includes('fetchRuleTargets') ?
                        <BobLoadingMask />
                        :
                        null
                }
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:    state.bob.activeNavCompany,
        bobLoading:          state.bob.bobLoading,
        targetsList:         state.rules.ruleTargetsList,
        targetsMeta:         state.rules.ruleTargetsMeta,
        workbookModeEnabled: state.dashboard.workbookModeEnabled
    };
};

const mapDispatchToProps = {
    ...BobActions,
    ...DashboardActions,
    ...ruleActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewTargets));
